import React, { useState } from 'react';
import './taskForm.css';
import { useDispatch, useSelector } from "react-redux";
import { selectAction, taskFormAction } from "../../redux/rootReducer";
import { SELECT_INITIAL, TASK_FORM_INITIAL } from "../../redux/initialStateConstant";
import TextareaAutosize from "react-textarea-autosize";
import { ChromePicker } from "react-color";
import { updateTaskSagaAction } from "../../redux/sagaActions";
import Select from "../Select/Select";
import { taskStatuses } from "../../helpers/taskStatuses";
import Checkbox from "../Checkbox/Checkbox";
import CalendarOffline from "../CalendarOffline/CalendarOffline";

const TaskForm = () => {
    const dispatch = useDispatch();
    const task_form = useSelector(state => state.task_form);

    let statuses = [
        { id: 'done', name: taskStatuses['done'] },
        { id: 'pending', name: taskStatuses['pending'] },
        { id: 'cancel', name: taskStatuses['cancel'] }
    ];

    // Состояние colorPicker
    const [colorPicker, setColorPicker] = useState(false);
    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__title">Задача</div>
                        <i className="form__close" onClick={ () => dispatch(taskFormAction(TASK_FORM_INITIAL)) } />
                    </div>
                    <div className="form__field">
                        <div className="task__color">
                            {
                                colorPicker
                                    ?
                                    <ChromePicker
                                        color={ task_form.color || '#fff' }
                                        onChangeComplete={ color => dispatch(taskFormAction({
                                            ...task_form,
                                            color: color.hex
                                        })) }
                                        className="task__color-picker"
                                    />
                                    : false
                            }
                            <div className="task__color-description">Цвет</div>
                            <div
                                className="task__color-template"
                                style={{ backgroundColor: task_form.color || '#fff' }}
                                onClick={ () => setColorPicker(!colorPicker) }
                            />
                        </div>
                        <div className="input__caption input__caption--required">Срок выполнения</div>
                        <div className="task__target">
                            <div
                                className="input input--datepicker"
                                onClick={ event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    setOpenCalendar(!openCalendar);
                                } }
                            >
                                { task_form.target_date ? new Date(task_form.target_date).toLocaleDateString('ru-Ru') : '' }
                            </div>
                            <input
                                type="time" className={ `input ${ task_form.target_time ? '' : 'input--empty' }` }
                                   value={ task_form.target_time }
                                   onChange={ event => dispatch(taskFormAction({
                                       ...task_form,
                                       target_time: event.target.value
                                   })) }
                            />
                        </div>
                        <CalendarOffline
                            date={ task_form.target_date }
                            handler={ date => {
                                dispatch(taskFormAction({
                                    ...task_form,
                                    target_date: date
                                }));
                                setOpenCalendar(false);
                            }}
                            open={ openCalendar }
                            close={ () => setOpenCalendar(false) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Описание задачи</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ task_form.description }
                            onInput={ event => dispatch(taskFormAction({
                                ...task_form,
                                description: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Ответственный</div>
                        <input type="text" className="input"
                            value={ task_form.responsible }
                            onInput={ event => dispatch(taskFormAction({
                                ...task_form,
                                responsible: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Статус</div>
                        <Select
                            current={ task_form.status.name }
                            type={ 'task_status' }
                            options={ statuses }
                            handler={ elem => {
                                dispatch(taskFormAction({
                                    ...task_form,
                                    status: elem
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                            smart={ false }
                        />
                    </div>
                    <div className="form__field">
                        <Checkbox
                            active={ task_form.urgent === '1' }
                            caption={ 'Срочная задача' }
                            handler={ () => dispatch(taskFormAction({ ...task_form, urgent: task_form.urgent === '1' ? '0' : '1' })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(updateTaskSagaAction({
                                id: task_form.id,
                                description: task_form.description,
                                target_date: task_form.target_date,
                                target_time: task_form.target_time,
                                responsible: task_form.responsible,
                                status: task_form.status.id,
                                color: task_form.color,
                                urgent: task_form.urgent
                            })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskForm;